export const en = {
    canNotBeEmpty: 'The value cannot be empty',
    emptyRegions: 'No regions selected',
    finishTimeShouldBeGreaterThanStartTime:
        'The impression end date and time must be later than the impression start date and time',
    incorrectVersion:
        'The version number is invalid. Enter an integer or decimal value. Use a dot as the decimal separator. Example: 6.14',
    invalidDate: 'Invalid date',
    invalidUrl: 'Invalid mobile app URL',
    invalidValue: 'Invalid value',
    invalidYandexUid: 'Invalid YandexUid. Enter a numeric value of 17 to 19 digits or a mask',
    multipleVersions: 'A targeting can only have one item with versions',
    numericInvalidValue: 'The value entered is not a number',
    numericNegativeValue: 'The value entered is negative',
    suggestInvalidValue: 'Unknown value. Select a value from the list',
    unknownError: 'Unknown error',
    valueShouldBeLessThan: 'The maximum value is {maxValue}',
    valueShouldBeMoreThan: 'The minimum value is {minValue}'
};
